module.exports = __webpack_public_path__ + "static/media/logo.2bb29004.png";